<template>
    <div id="consent">
        <consent-banner v-if="bannerIsOpen" :class="{ bannerIsCovered: configIsOpen }" @save-choice="saveChoice"> </consent-banner>
        <consent-config v-if="configIsOpen" :statistics="consent.statistics" :other="consent.other" @close="closeConfig" @save-choice="saveChoice"> </consent-config>
    </div>
</template>
<script>
import ConsentBanner from "./ConsentBanner.vue";
import ConsentConfig from "./ConsentConfig.vue";

const STORAGE_ITEM_NAME = "CONSENT";

export default {
    components: {
        ConsentBanner,
        ConsentConfig
    },
    provide() {
        return {
            openConfig: this.openConfig,
            openPrivacypolicy: this.openPrivacypolicy
        };
    },
    data() {
        return {
            bannerIsOpen: false,
            configIsOpen: false,
            consent: {
                statistics: false,
                other: false,
                timestamp: null,
                initDecision: null
            },
            decision: false
        };
    },
    created() {
        this.load();
        // console.log(" === $consent loaded =>", this.consent.statistics, this.consent.other, this.consent.initDecision, "===");
    },
    methods: {
        closeConfig() {
            // console.log('closeConfig')
            this.configIsOpen = false;
        },
        openConfig() {
            // console.log('open config')
            this.configIsOpen = true;
        },
        openPrivacypolicy() {
            // console.log("[consent>index.js] i18n.locale: ", this.$i18n.locale);
            const language = this.$i18n.locale.substring(0, 2);
            const domain = this.webcc.domain.domain;
            // console.log("[consent>index.js] domain: ", domain);
            // const isIC = domain.startsWith("interchalet");
            // const isIhFr = (domain === "interhome.fr");

            let pplink;
            switch (domain) {
                case "interhome.be":
                    pplink = "/customer-service/privacybeleid/";
                    break;
                case "interhome.cz":
                    pplink = (language === "cs") ? "/zakaznicky-servis/ochrana-soukromi/": "/en/customer-service/privacy-policy/";
                    break;
                case "interhome.dk":
                    pplink = "/kundeservice/databeskyttelse/";
                    break;
                case "interhome.de":
                    pplink = "/kundenservice/datenschutz/";
                    break;
                case "interhome.es":
                    pplink = "/servicio-al-cliente/politica-de-privacidad/";
                    break;
                case "interhome.ee":
                    pplink = (language === "en") ? "/customer-service/tietosuojaseloste/": "/fi/asiakaspalvelu/tietosuojaseloste/";
                    break;
                case "interhome.fr":
                    pplink = "/services-client/protection-des-donnees/";
                    break;
                case "interhome.co":
                    pplink = ".uk/customer-service/privacy-policy/";
                    break;
                case "interhome.hr":
                    pplink = "/usluge-za-goste/izjava-o-privatnosti/";
                    break;
                case "interhome.ie":
                    pplink = "/customer-service/privacy-policy/";
                    break;
                case "interhome.it":
                    pplink = "/servizio-clienti/privacy-policy/";
                    break;
                case "interhome.nl":
                    pplink = "/klanten-service/privacybeleid/";
                    break;
                case "interhome.no":
                    pplink = "/kundeservice/behandling-av-personoppgifter/";
                    break;
                case "interhome.at":
                    pplink = "/kundenservice/datenschutz/";
                    break;
                case "interhome.pl":
                    pplink = "/strefa-klienta/polityka-prywatnosci/";
                    break;
                case "interhome.pt":
                    pplink = "/apoio-ao-cliente/politica-de-privacidade/";
                    break;
                case "interhome.ch":
                    if (language === "de") {
                        pplink = "/kundenservice/datenschutz/";
                    }else if (language === "fr") {
                        pplink = "/fr/services-client/protection-donnees/";
                    }else{
                        pplink = "/it/customer-service/privacy-policy/";
                    }
                    break;
                case "interhome.fi":
                    pplink = "/asiakaspalvelu/tietosuojaseloste/";
                    break;
                case "interhome.se":
                    pplink = "/kundservice/behandling-av-personuppgifter/";
                    break;
                case "interhome.com":
                    pplink = "/customer-service/privacy-policy/";
                    break;
                case "interhome.com.au":
                    pplink = "/customer-service/privacy-policy/";
                    break;
                case "bookinterhome.ca":
                    pplink = "/customer-service/privacy-policy/";
                    break;
                case "interhome.in":
                    pplink = "/customer-service/privacy-policy/";
                    break;
                case "interhome.ru":
                    pplink = "/сервис/политика-конфиденциальности/";
                    break;
                case "partners.interhomeusa.com":
                    pplink = "/customer-service/privacy-policy/";
                    break;
                case "interchalet.de":
                    pplink = "/wichtige-hinweise/datenschutz/";
                    break;
                case "interchalet.co":
                    pplink = ".uk/important-notes/data-protection/";
                    break;
                case "interchalet.es":
                    pplink = "/notas-importantes/proteccion-de-datos/";
                    break;
                case "interchalet.fr":
                    pplink = "/informations-importantes/protection-des-donnees/";
                    break;
                case "interchalet.it":
                    pplink = "/informazioni-importanti/trattamento-dati-personali/";
                    break;
                case "interchalet-vakantiehuis.nl":
                    pplink = "/belangrijke-opmerkingen/privacybeleid/";
                    break;
                case "interchalet.pl":
                    pplink = "/wazne-wskazowki/ochrona-danych-osobowych/";
                    break;
            }
            // console.log("[consent>Consent] pplink: ", pplink);
            window.location.href = pplink;
        },
        saveChoice(opts) {
            // console.log('saveChoice angekommen', opts)
            this.consent = { timestamp: new Date(), statistics: opts.statistics, other: opts.other, initDecision: this.consent.initDecision === null ? true : false };
            const storage = window.localStorage;
            storage.setItem(STORAGE_ITEM_NAME, JSON.stringify(this.consent));
            this.bannerIsOpen = false;
            this.configIsOpen = false;
            // if (this.consent.initDecision === false) window.location.reload();
        },
        load() {
            const storage = window.localStorage;
            const consent = storage.getItem(STORAGE_ITEM_NAME);
            if (consent) {
                this.consent = JSON.parse(consent);
            }
            // console.log('loaded:', this.consent)
        },
        getDecision() {
            if (window.parent !== window || window.location.search.includes("iniframe")) {
                this.consent.timestamp = new Date(); // verhindert das Öffnen des Banners in waitForDecision()
                return { statistics: true, other: true, pseudoconsent: true };
            }
            return this.consent.timestamp ? this.consent : false;
        },
        waitForDecision() {
            return new Promise(resolve => {
                // wenn kein consent.timestamp vorhanden, das Banner anzeigen
                if (!this.consent.timestamp) this.bannerIsOpen = true;

                // und auf einen Consent warten
                const watcher = this.$watch(
                    () => this.consent.timestamp,
                    nv => {
                        if (nv) {
                            resolve(this.consent);
                            watcher(); // cleanup;
                        }
                    }
                );
            });
        }
    }
};
</script>

<style scoped>
/* CSS Konzept Cookie Consent
*
- Prinzip: Damit der Cookie Consent ohne große Anpassungen in verschiedenen Anwendungen eingesetzt werden kann, werden Abhängigkeiten bewusst vermieden
- Das bedeutet zunächst: KEIN SASS -> KEIN IMPORT VON SASS-DATEIEN, KEINE SASS-NOTATION, KEINE SASS-VARIABLEN
- Es werden auch keine eigenen CSS-Variablen definiert, weil das für den IE11 im Pseudoelement :root geschehen müsste, was vermieden werden soll
- Für bestimmte Farben können - sofern in der Applikation definiert - externe CSS-Variablen herangezogen werden. Dadurch können z.B. Domain- oder Company-abhängige Farben gesetzt werden
- Stehen die externen CSS-Variablen nicht zur Verfügung, weil sie nicht definiert wurden, greift ein Defaultwert (hier: Interhome-Farben, kann jedoch bei Bedarf geändert werden)
*
- Grundsätzlich kann natürlich alles nach Bedarf angepasst / überschrieben werden, dabei aber das Ziel der Einheitlichkeit nicht aus den Augen verlieren
*
*/

#consent {
    position: relative;
    /* z-index-Wert abhängig vom Einbindungskontext, auch z-index: 1 oder kein Wert kann ausreichend sein */
    z-index: 30;
    line-height: 1.5rem;
}
.bannerIsCovered {
    filter: grayscale(90%);
}

::v-deep .button-cta {
    font-size: 0.875rem;
    padding: 0.375rem 1rem;
    min-width: 10rem;
    background-color: var(--color-primary, #0096db);
    color: #fff;
    border: 1px solid transparent;
    border-radius: 4px;
    cursor: pointer;
}

::v-deep .button-std {
    font-size: 0.875rem;
    padding: 0.375rem 1rem;
    min-width: 12rem;
    background-color: #fff;
    color: #424242;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    cursor: pointer;
}

@media (min-width: 768px) {
    ::v-deep .button-std {
        font-size: 1rem;
    }
    ::v-deep .button-cta {
        font-size: 1rem;
    }
}

::v-deep .button-cta:hover {
    background-color: var(--color-secondary, #e63957);
}
</style>
